<ng2-completer #completerWidget
               [textNoResults]=""
               class="completer-limit"
               [datasource]="dataService"
               [minSearchLength]="1"
               [inputClass]="'form-control border-no-radius'"
               [openOnFocus]="false"
               [openOnClick]="false"
               [autoMatch]="true"
               [autoHighlight]="true"
               [fillHighlighted]="false"
               [autofocus]="hasfocus"
               [clearUnselected]="false"
               [(ngModel)]="value"
               (selected)="onSelected($event)"
               (opened)="onOpened($event)"
               (click)="onClick()"
               (focus)="openCloseFocused = true"
               (blur)="openCloseFocused = false; propagateTouch(completerWidget); onBlur();"
               (ngModelChange)="onChange()">
</ng2-completer>
